import React from "react";
import { mockProducts } from "../../../mock";
import useInViewOnce from "../useInViewOnce";
import ProductCard from "../../../components/product/ProductCard";

const ProductsSection = () => {
  const [setRef, isInView] = useInViewOnce();

  return (
    <section id="produk" className="px-4 mb-12 sm:px-6 md:px-0 md:mb-20">
      <div
        ref={setRef}
        className={`${
          isInView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"
        } transition-all duration-500 ease-out`}
      >
        {/* HEADER */}
        <header className="max-w-xl mb-6 md:mb-10">
          <h2 className="text-base font-semibold tracking-tight text-foreground sm:text-lg md:text-xl">
            Satu Bumbu, Banyak Menu Khas Aceh
          </h2>
          <p className="mt-1 text-xs text-muted-foreground sm:text-sm">
            Bumbu CINEURASA diracik dengan rempah autentik Aceh agar praktis,
            fleksibel, dan konsisten di setiap masakan.
          </p>
        </header>

        {/* PRODUCT LIST */}
        <div className="grid grid-cols-1 gap-5 sm:gap-6 md:grid-cols-2">
          {mockProducts.map((product, index) => (
            <ProductCard
              key={product.id}
              product={product}
              delay={isInView ? index * 120 : 0}
            />
          ))}
        </div>

        {/* FOOTNOTE */}
        {/* <p className="mt-4 text-[11px] text-muted-foreground sm:mt-5">
          Ilustrasi menu digunakan untuk keperluan visual. Produk dikirim dalam
          kemasan resmi CINEURASA.
        </p> */}
      </div>
    </section>
  );
};

export default ProductsSection;
